/****************************************************
 * Module Name:  issueMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Avatar, Box, Button, Chip, Tooltip, Typography, } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import KapanCreationProxy from "../../utility/proxy/manager/manufacturingProxy/kapanCreationProxy";
import AddIssue from "./addIssueModal";
import AddPackage from "./addPackage";
import AddPackageDetail from "./addPackageDetail";
import { GiPowderBag } from 'react-icons/gi'
import UserProxy from "../../utility/proxy/manager/userProxy";
import { MdSendToMobile } from "react-icons/md";
import PacketProxy from "../../utility/proxy/manager/manufacturingProxy/packetProxy";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import { RiRedPacketFill } from "react-icons/ri";
import { MdCancelScheduleSend } from "react-icons/md";
import ConfirmationModal from "../common/confirmationModal";
import { LoadingButton } from "@mui/lab";
import { MdOutlineNotificationsActive } from "react-icons/md";
import PageTitle from "../common/pageTitle";

export class IssueMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      issue: [],
      showAddIssueModal: false,
      showPackageModal: false,
      packageloadingButton: false,
      showPackageDetailModal: false,
      packageDetailloadingButton: false,
      weight: 0,
      editOperation: false,
      sourceData: {},
      selectionModel: [],
      totalKapanPcs: 0,
      kapanPpc: 0,
      kapanCarats: 0,
      loadingButton: false,
      reIssue: false,
      headAvailable: "loading",

      kapanid: "",
      totalPacketCount: "",
      isKapanStatusNew: "",
      confirmModalMessage: "",
      confirmModalTitle: "",
      showKapanDetailModal: false,
      showIssueLoadSpinner: true,
      cancelLoader: false,
      notifyLoader: false,
      showCancelConfirmationModal: false,
      snackbarVariant: "",
      snackbarMessage: "",
      showSnackbar: "",

      totalKapan: 0,
      totalPrice: 0,
      totalCarats: 0,
      avgPrice: 0,
      columnNames: [],
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEIPT
      ),
      packaging_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.MANUFACTURING_PACKAGING
      ),
    };
    this.fetchIssueData(false);
  }

  componentDidMount() {
    PageTitle("MANUFACTURING_OPERATION_KAPANISSUE");
  }

  fetchIssueData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showIssueLoadSpinner: true });
    UserProxy.CheckIsUserHead(Constants.loggedInUser.id, (response) => {
      response !== undefined && response.status === "success"
        ?
        KapanCreationProxy.GetKapanCreationByUserId(
          (responseData) => {
            if (responseData) {
              this.setState({
                issue: responseData,
                showIssueLoadSpinner: false,
                headAvailable: true,
              })
              const filterMap = this.generateFilterMap(Array.isArray(responseData) ? responseData : [responseData]);
              this.getSummaryReport(responseData);
              this.prepareColumns(filterMap);
            } else {
              this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
              this.setState({
                headAvailable: true,
                showIssueLoadSpinner: false,
              });
            }
          }
        )
        :
        this.setState({
          headAvailable: false,
          showIssueLoadSpinner: false,
        });
    });
  };

  generateFilterMap = (responseData) => {
    const filterMap = {};

    // Process department 
    const department = responseData.map((dept) => ({
      id: dept.departmentid,
      username: dept.departmentname,
    }));

    filterMap.departmentname = [
      ...new Set(
        department.map((group) => `${group.id} | ${group.username}`)
      ),
    ];

    // Process department Group
    const departmentGroup = responseData.map((dept) => ({
      id: dept.departmentgroupid,
      username: dept.departmentgroupname,
    }));

    filterMap.departmentgroupname = [
      ...new Set(
        departmentGroup.map((group) => `${group.id} | ${group.username}`)
      ),
    ];

    // Process issued department head
    const issuedDeptHead = responseData.map((dept) => ({
      id: dept.nextdepartmentheadid,
      username: dept.nextdepartmentheadname,
    }));

    filterMap.nextdepartmentheadname = [
      ...new Set(
        issuedDeptHead.map((group) => `${group.id} | ${group.username}`)
      ),
    ];

    // Process issued department name
    const issuedDept = responseData.map((dept) => ({
      id: dept.nextdepartmentid,
      username: dept.nextdepartmentname,
    }));

    filterMap.nextdepartmentname = [
      ...new Set(
        issuedDept.map((group) => `${group.id} | ${group.username}`)
      ),
    ];


    // Process department 
    const process = responseData.map((dept) => ({
      id: dept.processid,
      name: dept.processname,
    }));

    filterMap.processname = [
      ...new Set(
        process.map((group) => `${group.id} | ${group.name}`)
      ),
    ];

    return filterMap;
  };

  getSummaryReport = (data) => {
    if (!Array.isArray(data)) return;
    let totalKapans = data.length;
    let carats = 0;
    let price = 0;
    data.forEach((item) => {
      carats += item.carats;
      price += item.carats * item.price;
    });
    let avgprice = price / carats;

    this.setState({
      totalKapan: totalKapans,
      totalPrice: price,
      totalCarats: carats,
      avgPrice: avgprice
    });
  }

  hideModal = () => {
    this.setState({
      showPackageDetailModal: false,
      showPackageModal: false
    });
  };

  setSnackbarState = (show, message, variant) => {
    this.setState({
      showSnackbar: show,
      snackbarMessage: message,
      snackbarVariant: variant,
    })
  }

  getpacketsDetail = (id) => {
    this.setState({ packetloadingButton: true });
    KapanCreationProxy.GetMyKapanDetail(id, false, (response) => {
      if (response) {
        this.setState({ showPackageDetailModal: true, showDetailModal: false, packetloadingButton: false, sourceData: response });
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({
          packetloadingButton: false,
        });
      }
    })
  }

  disableCancelAndNotify = () => {
    if (this.state.selectionModel.length === 0) return true;
    return this.state.selectionModel.some(iData => {
      const matchingRow = this.state.issue.find(iRow => iRow.id === iData);
      return matchingRow && matchingRow.nextdepartmentheadid === null && matchingRow.nextdepartmentid === null;
    });
  };

  handleCancelIssue = () => {
    this.setState({
      showCancelConfirmationModal: true,
      confirmModalMessage: "Are you sure you want to cancel issue for the selected kapan?",
      confirmModalTitle: "Cancel Issue"
    });
  }

  handleNotifyUser = () => {
    this.setState({ notifyLoader: true });
    KapanCreationProxy.NotifyUser(this.state.selectionModel, (response) => {
      if (response) {
        this.setSnackbarState(true, "Notification Sent Successfully", "success");
        this.setState({ notifyLoader: false, selectionModel: [] });
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({ notifyLoader: false, selectionModel: [] });
      }
    })
  };

  handleCancelIssueKapan = () => {
    this.setState({ cancelLoader: true });
    KapanCreationProxy.CancelIssue(this.state.selectionModel, (response) => {
      if (response) {
        this.setState({ cancelLoader: false, showCancelConfirmationModal: false, selectionModel: [] });
        this.setSnackbarState(true, response.errorMessage, response.status);
        this.fetchIssueData(true);
      } else {
        this.setState({ cancelLoader: false, showCancelConfirmationModal: false });
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
      }
    })
  };

  handleKapanDetailModal = (params) => {
    this.setState({ kapanid: params, showKapanDetailModal: true });
  };

  prepareColumns = (uniqueFilterValues) => {

    const columnNames = this.columnsWithoutPermission.map(woPermissionColumn => {
      let guids = [];

      // Determine which GUIDs (permissions) should be added based on the column field

      switch (woPermissionColumn.field) {
        case "id":
          guids = [
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_USER,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_PCS,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_CARATS,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_PRICE,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_TOTAL,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_DEPARTMENT,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_DEPARTMENT_GROUP,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_NEXT_DEPARTMENT_HEAD,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_NEXT_DEPARTMENT,
          ];
          break;
        case "processname":
          guids = [
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_CREATEDAT,
          ];
          break;
        default:
          guids = [];
      }

      // Retrieve valid permission columns
      return this.fetchColumnDataFromGuid(guids, woPermissionColumn, this.columnsWithPermission, uniqueFilterValues);

    }).flat(); // Flatten the array

    // Update state with the prepared columns
    this.setState({
      columnNames: columnNames
    })
  };

  fetchColumnDataFromGuid = (guids, currentColumn, columnsWithPermission, uniqueFilterValues) => {

    const permissionColumns = guids
      .map(id => Constants.USER_COLUMN_PERMISSION.find(permission => permission === id)) // Match permissions
      .filter(Boolean) // Remove undefined values (invalid permissions)
      .map(guid => {
        const columnData = columnsWithPermission[guid]; // Get column details

        // If the columnData is missing or an empty object, skip adding it
        if (!columnData || Object.keys(columnData).length === 0) {
          return null;
        }

        if (columnData.field === "departmentname") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.departmentname : [];
          columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'departmentid', 'departmentname');
        }
        if (columnData.field === "departmentgroupname") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.departmentgroupname : [];
          columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'departmentgroupid', 'departmentgroupname');
        }
        if (columnData.field === "nextdepartmentheadname") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.nextdepartmentheadname : [];
          columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'nextdepartmentheadid', 'nextdepartmentheadname');
        }
        if (columnData.field === "nextdepartmentname") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.nextdepartmentname : [];
          columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'nextdepartmentid', 'usernamnextdepartmentnamee');
        }

        return columnData;

      })
      .filter(Boolean); // Remove any null values from the list

    if (currentColumn.field === "processname") {
      currentColumn.type = "singleSelect";
      currentColumn.valueOptions = uniqueFilterValues ? uniqueFilterValues.processname : [];
      currentColumn.filterOperators = Utility.customFilters(uniqueFilterValues, currentColumn.field, 'processid', 'processname');
    }
    // Modify the original column before adding it to the list
    const modifiedColumn = {
      ...currentColumn,  // Retain original column properties
      valueOptions: uniqueFilterValues[currentColumn.field] || [], // Assign filter values
    };

    // Return an array with the modified column and any valid permission columns
    return [modifiedColumn, ...permissionColumns];
  };

  columnsWithPermission = {
    "01b85657-9c59-4cda-9c3c-05ea1fd72c7d": {
      field: "pcs",
      headerName: "PCS",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value,
    },
    "eebb216a-fc07-4240-984c-55abad8655f8": {
      field: "carats",
      headerName: "CTS",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "8a5f7bcf-0623-4bcc-a449-24ab91c75997": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "87705e55-c76c-46a4-a15b-da129da04e36": {
      field: "userId",
      headerName: "USER ID",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "number",
      valueFormatter: (params) => params.value,
    },
    "291073dc-bce6-4b03-9204-9c887e5db384": {
      field: "departmentname",
      headerName: "DEPARTMENT",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (params) => (
        <Box sx={{ minHeight: "auto", mt: 1 }}>
          <Chip
            avatar={<Avatar>{params.row.departmentid}</Avatar>}
            label={params.row.departmentname}
            sx={{ margin: "0px 10px 10px 0px" }}
          />
        </Box>
      ),
      disableExport: true,
    },
    "13828a45-d41b-402c-a484-41be812749d8": {
      field: "departmentgroupname",
      headerName: "DEPARTMENT GROUP",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (params) => (
        <Box sx={{ minHeight: "auto", mt: 1 }}>
          <Chip
            avatar={<Avatar>{params.row.departmentgroupid}</Avatar>}
            label={params.row.departmentgroupname}
            sx={{ margin: "0px 10px 10px 0px" }}
          />
        </Box>
      ),
      disableExport: true,
    },
    "9b81bf25-e3ab-44fd-99e1-c2b1513ea7d0": {
      field: "nextdepartmentheadname",
      headerName: "ISSUED DEPARTMENT HEAD",
      headerAlign: "center",
      align: "center",
      width: 190,
      renderCell: (params) => (
        params.row.nextdepartmentheadid ?
          <Box sx={{ minHeight: "auto", mt: 1 }}>
            <Chip
              avatar={<Avatar>{params.row.nextdepartmentheadid}</Avatar>}
              label={params.row.nextdepartmentheadname}
              sx={{ margin: "0px 10px 10px 0px" }}
            />
          </Box>
          : '-'
      ),
      disableExport: true,
    },
    "92edf402-af32-4081-aa3c-8bd94dbb2fc2": {
      field: "nextdepartmentname",
      headerName: "ISSUED DEPARTMENT NAME",
      headerAlign: "center",
      align: "center",
      width: 190,
      renderCell: (params) => (
        params.row.nextdepartmentid ?
          <Box sx={{ minHeight: "auto", mt: 1 }}>
            <Chip
              avatar={<Avatar>{params.row.nextdepartmentid}</Avatar>}
              label={params.row.nextdepartmentname}
              sx={{ margin: "0px 10px 10px 0px" }}
            />
          </Box> : '-'
      ),
      disableExport: true,
    },
    "f277d253-9fb9-4c5f-9f2f-3e13fb44b1cf": {
      field: "createdAt",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "c9623b57-4e0d-48b7-8532-ed2fbbd4304b": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (params.row.carats * params.row.price).toFixed(2),
    },
  };

  columnsWithoutPermission = [
    {
      field: "id",
      headerName: "KAPANID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black',
          }}
          onClick={() => this.handleKapanDetailModal(params.value)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "processname",
      headerName: "CURRENT PROCESS",
      headerAlign: "center",
      align: "center",
      width: 250,
      renderCell: (params) => {
        if (params.row.processid == null || params.row.processname == null)
          return '-';
        return (
          <Box sx={{ minHeight: "auto", mt: 1 }}>
            <Chip
              avatar={<Avatar>{params.row.processid}</Avatar>}
              label={params.row.processname}
              sx={{ margin: "0px 10px 10px 0px" }}
            />
          </Box>
        )
      },
      disableExport: true,
    },
    {
      field: "issue",
      headerName: "ISSUE",
      headerAlign: "center",
      align: "center",
      width: 150,

      renderCell: (params) => {
        const { row } = params;
        const isKapanStatusNew = row.status === "NEW";
        if ((Utility.isAddAllowed(this.state.local_Permission) || Utility.isUpdateAllowed(this.state.local_Permission)) && isKapanStatusNew) {
          return (
            <Button
              startIcon={<MdSendToMobile />}
              sx={{ width: 150 }}
              color={params.row.nextdepartmentid === null || params.row.nextdepartmentheadid === null ? 'primary' : 'success'}
              variant="contained"
              onClick={() =>
                this.setState({
                  showAddIssueModal: true,
                  editOperation: false,
                  sourceData: params.row,
                  loadingButton: false,
                  reIssue: params.row.nextdepartmentid === null || params.row.nextdepartmentheadid === null ? false : true
                })
              }
            >
              {
                params.row.nextdepartmentid === null || params.row.nextdepartmentheadid === null ? 'Issue' : 'Re-Issue'
              }
            </Button>
          );
        }
        return '-';
      },
      disableExport: true,
    },
    {
      field: "package",
      headerName: "PACKETS",
      headerAlign: "center",
      align: "center",
      width: 200,

      renderCell: (params) => {
        const { row } = params;
        const isPendingDepartment = row.nextdepartmentheadid === null || row.nextdepartmentid === null;
        const isKapanStatusNew = row.status === "NEW";
        const isKapanStatusInProgress = row.status === "PACKAGE_INPROGRESS";

        const handleUpdatePackage = (e) => {
          e.stopPropagation();

          this.setState({ isKapanStatusNew, kapanid: row.id, totalKapanPcs: row.pcs, kapanPpc: row.price, kapanCarats: row.carats });
          this.getpacketsDetail(row.id);
        };

        const handleCreatePackage = (e) => {
          e.stopPropagation();
          this.setState({
            showPackageModal: true,
            editOperation: false,
            sourceData: row,
            packageloadingButton: false,
            isKapanStatusNew,
            kapanPpc: row.price,
            totalKapanPcs: row.pcs,
            kapanCarats: row.carats
          });
        };

        if (isPendingDepartment && isKapanStatusInProgress && Utility.isUpdateAllowed(this.state.packaging_Permission)) {
          return (
            <Button
              startIcon={<GiPowderBag />}
              sx={{ width: 200 }}
              color="success"
              variant="contained"
              onClick={handleUpdatePackage}
            >
              Update Package
            </Button>
          );
        }

        if (isPendingDepartment && isKapanStatusNew && Utility.isAddAllowed(this.state.packaging_Permission)) {
          return (
            <Button
              startIcon={<RiRedPacketFill />}
              sx={{ width: 200 }}
              variant="contained"
              onClick={handleCreatePackage}
            >
              Create Package
            </Button>
          );
        }

        return "-";
      },
      disableExport: true,
    },
  ];

  hideAddIssueModal = () => {
    this.setState({
      showAddIssueModal: false,
      showPackageModal: false,
      showPackageDetailModal: false,
    });
  };

  handleValidation = (IssueData) => {
    //TODO do validation if needed here
    return true;
  };

  addIssue = (IssueData) => {
    this.setState({ loadingButton: true });
    //Creating new issue, and once issue is created on call refresh the list of current issue
    KapanCreationProxy.AddIssue(IssueData, (response) => {
      if (response) {
        this.fetchIssueData(true);
        this.setState({ loadingButton: false, showAddIssueModal: false });
        this.setSnackbarState(true, response.errorMessage, response.status);
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({ loadingButton: false, showAddIssueModal: false });
      }
    });
  };

  addPackage = (packageData) => {
    this.setState({ packageloadingButton: true });
    if (packageData && packageData.totalpackets) {
      this.setState({
        kapanid: packageData.kapanid,
        totalPacketCount: packageData.totalpackets,
        showPackageModal: false,
        packageloadingButton: false,
        showPackageDetailModal: true,
      });
    } else {
      this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
      this.setState({
        packageloadingButton: false,
      });
    }

  };

  AddPackageDetail = (packageData) => {
    this.setState({ packageDetailloadingButton: true });
    //Creating new issue, and once issue is created on call refresh the list of current issue
    PacketProxy.AddPackets(packageData, this.state.kapanid, (response) => {
      if (response) {
        this.fetchIssueData(false);
        this.setState({ packageDetailloadingButton: false })
        this.hideModal();
        this.setSnackbarState(true, "Packet added or updated successfully ", "success");
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({
          packageDetailloadingButton: false,
        });
      }
    });
  };

  render() {
    const rows = this.state.issue;
    const col = (Utility.isAddAllowed(this.state.local_Permission) || Utility.isUpdateAllowed(this.state.local_Permission))
      ? this.state.columnNames
      : this.state.columnNames.filter(
        (col) => col.field !== "issue"
      );
    const columns = (Utility.isAddAllowed(this.state.packaging_Permission) || Utility.isUpdateAllowed(this.state.packaging_Permission))
      ? col
      : col.filter(
        (col) => col.field !== "package"
      );
    return (
      <div>
        <CommonSnackbar
          show={this.state.showSnackbar}
          message={this.state.snackbarMessage}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={this.state.snackbarVariant === "success" ? "Success" :
            this.state.snackbarVariant === "error" ? "Failed" : "Warning"}
          handleClose={
            () => {
              this.setState({
                showSnackbar: false
              })
            }
          }
        />

        {this.state.showKapanDetailModal ? (
          <KapanHistoryModal
            show={this.state.showKapanDetailModal}
            kapanId={this.state.kapanid}
            close={() => this.setState({ showKapanDetailModal: false })}
          />
        ) : null}
        <Box sx={{ width: "100%", height: "100%" }}>
          {this.state.showAddIssueModal ? (
            <AddIssue
              Show={true}
              handleClose={this.hideAddIssueModal}
              handleSave={this.addIssue}
              handleValidation={this.handleValidation}
              loading={this.state.loadingButton}
              sourceData={this.state.sourceData}
              reIssue={this.state.reIssue}
            />
          ) : (
            <Box />
          )}

          {this.state.showCancelConfirmationModal ? (
            <ConfirmationModal
              show={true}
              setShow={(value) => this.setState({ showCancelConfirmationModal: value })}
              handleSave={this.handleCancelIssueKapan}
              modalTitle={this.state.confirmModalTitle}
              modalMessage={this.state.confirmModalMessage}
              loading={this.state.cancelLoader}
            />
          ) : null}

          {this.state.showPackageModal ? (
            <AddPackage
              Show={true}
              handleClose={this.hideAddIssueModal}
              handleSave={this.addPackage}
              handleValidation={this.handleValidation}
              loading={this.state.packageloadingButton}
              sourceData={this.state.sourceData}
              kapanToPacket={true}
            />
          ) : (
            <Box />
          )}

          {this.state.showPackageDetailModal ? (
            <AddPackageDetail
              Show={true}
              handleClose={this.hideModal}
              handleSave={this.AddPackageDetail}
              handleValidation={this.handleValidation}
              loading={this.state.packageDetailloadingButton}
              sourceData={this.state.sourceData}
              fromKapan={true}
              kapanId={this.state.kapanid}
              isKapanStatusNew={this.state.isKapanStatusNew}
              isPacketStatusNew={null}
              fromPacketId={null}
              addPacketPermission={Utility.isAddAllowed(this.state.packaging_Permission)}
              totalPacketCount={this.state.totalPacketCount}
              kapanPcs={this.state.totalKapanPcs}
              kapanppc={this.state.kapanPpc}
              maxCarats={this.state.kapanCarats}
            />
          ) : (
            <Box />
          )}
          {this.state.headAvailable === "loading" ? (
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "transition(-50%, -50%)",
              }}
            >
              <CircularProgress size="4rem" />
            </Box>
          ) : !this.state.headAvailable ? (
            <Box>
              <Typography>
                Currently you are not heading any department
              </Typography>
            </Box>
          ) : (
            <Box>
              <Box px={1}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    color: '#000',
                    width: "100%",
                    position: "relative",
                    "& .MuiTablePagination-selectLabel": {
                      marginTop: "15px",
                    },
                    "& .MuiTablePagination-displayedRows": {
                      marginTop: "15px",
                    },
                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    "& .css-cc8tf1": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    height: "77vh",
                  }}
                >
                  <DataGridPro
                    disableRowSelectionOnClick={true}
                    getRowHeight={() => "auto"}
                    sx={{
                      '& .MuiDataGrid-columnHeader': {
                        color: '#fff',
                        backgroundColor: 'grey',
                      },
                      "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                        py: "4px",
                      },
                      "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                        py: "12px",
                      },
                      "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                        py: "18px",
                      },
                      fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                    }}
                    density="compact"
                    slots={{ toolbar: GridToolbar }}
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    loading={this.state.showIssueLoadSpinner}
                    checkboxSelection={true}
                    onRowSelectionModelChange={(newSelectionModel) => {
                      this.setState({ selectionModel: newSelectionModel });
                    }}
                    rowSelectionModel={this.state.selectionModel}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          // Hide columns status and traderName, the other columns will remain visible
                        },
                      },
                      pagination: {
                        paginationModel: Constants.pageSize,
                      },
                    }}
                    pageSizeOptions={Constants.pageSizeOptions}
                    pagination
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: "11px",
                      left: "590px",
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '36rem',
                      color: "black",
                      fontWeight: 'normal',
                      fontSize: Constants.defaultTableFontSize
                    }}
                  ><p style={{ margin: 0 }}>
                      <span>Total Kapan:</span> <b>{this.state.totalKapan}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                      <span>Total Carats: </span> <b>{this.state.totalCarats.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                      <span>Total Price: </span> <b>{this.state.totalPrice.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                      <span>Avg Price: </span> <b>{isNaN(this.state.avgPrice) ? "0.00" : this.state.avgPrice.toFixed(2)}</b></p>
                  </Box>
                  <Box
                    style={{
                      position: "absolute",
                      top: 5,
                      right: "270px",
                      display: "flex",
                      flexWrap: "nowrap",
                    }}
                  >
                    {this.state.showIssueLoadSpinner ? (
                      <CircularProgress size="25px" sx={{ lineHeight: -2 }} />
                    ) : (
                      <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                          color="primary"
                          fontSize="medium"
                          onClick={() => this.fetchIssueData(true)}
                          sx={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}
                    {Utility.isUpdateAllowed(this.state.local_Permission) ? (
                      <Tooltip title="Notfiy">
                        <LoadingButton
                          component="label"
                          variant="outlined"
                          size="small"
                          sx={{ ml: "5px" }}
                          loading={this.state.notifyLoader}
                          loadingPosition="start"
                          startIcon={<MdOutlineNotificationsActive size={20} />}
                          disabled={this.disableCancelAndNotify()}
                          onClick={() => this.handleNotifyUser()}
                        >
                          Notify
                        </LoadingButton>
                      </Tooltip>
                    ) : null}
                    {Utility.isUpdateAllowed(this.state.local_Permission) ? (
                      <Tooltip title="Cancel">
                        <Button
                          component="label"
                          variant="outlined"
                          size="small"
                          sx={{ ml: "5px" }}
                          startIcon={<MdCancelScheduleSend size={20} />}
                          disabled={this.disableCancelAndNotify()}
                          onClick={() => this.handleCancelIssue()}
                        >
                          Cancel
                        </Button>
                      </Tooltip>
                    ) : null}
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </div>
    );
  }
}

export default IssueMaster;
